import React, { useEffect, useRef, useState } from "react"
import { motion } from "framer-motion"
import Slide from "./Slide"
import useGlobalContext from "../context/GlobalContext"
import Culture from "./Culture"
import Loading from "./Loading"

const Slider = ({ isLoading, slides, title, culture, padSm, padTo }) => {
  const { changeCursor } = useGlobalContext()
  const sliderWrapperRef = useRef(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    if (isLoading) return
    setWidth(
      sliderWrapperRef.current?.scrollWidth -
        (sliderWrapperRef.current?.offsetWidth -
          parseFloat(
            window
              .getComputedStyle(sliderWrapperRef.current?.children[0])
              .getPropertyValue("gap")
          ))
    )
  }, [isLoading])

  return (
    <section
      data-scroll-section
      className={`slider ${padSm ? "padding-sm" : ""} ${
        padTo ? "padding-top" : ""
      }`}
    >
      <div className="wrapper">
        <h2 className={`title-md ${culture ? "accent" : ""}`}>{title}</h2>
      </div>
      <motion.div
        onMouseEnter={() => changeCursor("drag")}
        onMouseLeave={() => changeCursor("")}
        className="wrapper slider-wrapper"
        ref={sliderWrapperRef}
      >
        <motion.div
          onDragStart={() => {
            sliderWrapperRef.current.classList.add("dragged")
          }}
          onDrag={() => {
            changeCursor("dragging")
          }}
          onDragEnd={() => {
            changeCursor("drag")
            sliderWrapperRef.current.classList.remove("dragged")
          }}
          drag="x"
          dragConstraints={{
            right: 0,
            left: -width,
          }}
          className="slides-wrapper"
        >
          {isLoading ? (
            <Loading />
          ) : culture ? (
            slides?.map((slide, i) => <Culture key={slide.img} slide={slide} />)
          ) : (
            slides?.map((slide) => <Slide key={slide.id} slide={slide} />)
          )}
        </motion.div>
      </motion.div>
    </section>
  )
}

export default Slider
